import { createContext, ReactNode, useContext } from 'react';

interface NavigationConfig {
  suppressViewTransitions: boolean;
}

const NavigationConfigContext = createContext<NavigationConfig>({ suppressViewTransitions: false });

export const NavigationConfigProvider: React.FC<{
  suppressViewTransitions: boolean;
  children: ReactNode;
}> = ({ suppressViewTransitions, children }) => (
  <NavigationConfigContext.Provider value={{ suppressViewTransitions }}>
    {children}
  </NavigationConfigContext.Provider>
);

export const useNavigationConfig = () => useContext(NavigationConfigContext);
